<template>
  <v-card class="report-row" flat>
    <div class="row">
      <v-col cols="12" md="6" class="report-row__title">
        {{item.name}}
      </v-col>
      <v-col cols="6" sm="8" md="3" class="report-row__details">
        {{item.quantity}} {{localType === 'ARTICLES' ? 'Kom' : articlesLabel}}
      </v-col>
      <v-col cols="6" sm="4" md="3" class="report-row__total" :inner-html.prop="item.sum | price(2)">
      </v-col>
    </div>
    <div class="row" v-if="item.articles">
      <div class="col-9 offset-1" v-for="article of item.articles" :key="article.name">
        <span class="article-quantity">{{article.quantity}}x</span> {{article.name}} <span class="float-right" :inner-html.prop="article.sum | price(2)"></span>
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    item: {
      required: true,
      type: Object
    },
    type: {
      required: true,
      type: String
    }
  },
  data () {
    return {
      localType: 'ARTICLES'
    }
  },
  computed: {
    articlesLabel () {
      if (this.item.quantity % 100 === 1) return 'Artikel'
      if (this.item.quantity % 100 === 2) return 'Artikla'
      if (this.item.quantity % 100 === 3) return 'Artikli'
      if (this.item.quantity % 100 === 4) return 'Artikli'
      return 'Artiklov'
    }
  },
  created () {
    this.localType = this.type
  }
}
</script>

<style lang="scss" scoped>
.report-row {
  padding: 0 15px;
  margin: 5px;
  font-size: 20px;
  border: 2px solid lightgrey;

  &__title {
    font-size: 23px;
  }
  &__details {
    font-size: 20px;
    color: grey;
  }
  &__total {
    padding-right: 20px;
    font-size: 30px;
    font-weight: bold;
  }
  .article-quantity {
    font-size: 20px;
    color: grey;
  }
}
</style>
